export default "__VITE_ASSET__BzDJ$jde__"